const routesConfig = [
    // { path: "/", changefreq: "daily", priority: 1.0 },
    // { path: "/company", changefreq: "monthly", priority: 0.7 },
    // { path: "/serviceunits", changefreq: "monthly", priority: 0.7 },
    // { path: "/news", changefreq: "weekly", priority: 0.7 },
    // { path: "/contact-us", changefreq: "monthly", priority: 0.6 },
    // { path: "/news/:id", changefreq: "weekly", priority: 0.6, excludeFromSitemap: true },
    // { path: "/solutions", changefreq: "monthly", priority: 0.7 },
    // { path: "/smart-growing", changefreq: "monthly", priority: 0.7 },
    // { path: "/business-partners", changefreq: "monthly", priority: 0.7 },
    // { path: "/bio-solutions", changefreq: "monthly", priority: 0.7 },
    // { path: "/enviro-solutions", changefreq: "monthly", priority: 0.7 },
    // { path: "/design", changefreq: "monthly", priority: 0.7 },
    // { path: "/privacy-statement", changefreq: "yearly", priority: 0.5 },
    // { path: "/terms-and-conditions", changefreq: "yearly", priority: 0.5 },
    // { path: "/product-list", changefreq: "monthly", priority: 0.8 },

    { path: "/:country", changefreq: "daily", priority: 1.0 },
    { path: "/:country/company", changefreq: "monthly", priority: 0.7 },
    { path: "/:country/serviceunits", changefreq: "monthly", priority: 0.7 },
    { path: "/:country/news", changefreq: "weekly", priority: 0.7 },
    { path: "/:country/contact-us", changefreq: "monthly", priority: 0.6 },
    { path: "/:country/news/:id", changefreq: "weekly", priority: 0.6, excludeFromSitemap: true },
    { path: "/:country/solutions", changefreq: "monthly", priority: 0.7 },
    { path: "/:country/smart-growing", changefreq: "monthly", priority: 0.7 },
    { path: "/:country/business-partners", changefreq: "monthly", priority: 0.7 },
    { path: "/:country/bio-solutions", changefreq: "monthly", priority: 0.7 },
    { path: "/:country/enviro-solutions", changefreq: "monthly", priority: 0.7 },
    { path: "/:country/design", changefreq: "monthly", priority: 0.7 },
    { path: "/:country/privacy-statement", changefreq: "yearly", priority: 0.5 },
    { path: "/:country/terms-and-conditions", changefreq: "yearly", priority: 0.5 },
    { path: "/:country/product-list", changefreq: "monthly", priority: 0.8 },
    { path: "/:country/product/:slug", changefreq: "monthly", priority: 0.9 },
    { path: "/:country/product-global-list", changefreq: "monthly", priority: 0.6 },
    { path: "/:country/product-b2b-list/:id", changefreq: "monthly", priority: 0.6 },
    { path: "/:country/product-b2b-contact/:id", changefreq: "monthly", priority: 0.6 },
    { path: "/:country/info", changefreq: "yearly", priority: 0.7 },
    { path: "/:country/investors", changefreq: "yearly", priority: 0.7 },
    // { path: "/:country/investors-new", changefreq: "yearly", priority: 0.7 },
    { path: "/:country/reports/:id/:year/:reportSlug", changefreq: "yearly", priority: 0.7, excludeFromSitemap: true },
    { path: "/:country/reports/:year/:reportSlug", changefreq: "yearly", priority: 0.7, excludeFromSitemap: true },
    { path: "/:country/reports/:id", changefreq: "yearly", priority: 0.7 },
    { path: "/:country/custom-solutions", changefreq: "yearly", priority: 0.7 },
    { path: "/:country/local-report", changefreq: "yearly", priority: 0.7 },

    { path: "*", changefreq: "monthly", priority: 0.1 },
];

export default routesConfig;
